import styled from 'styled-components'

export const ProgressiveLabel = styled.span`
  font-family: 'Lato', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 14px;
  margin-bottom: 16px;
  color: #115850;
`

export const ProgressiveValue = styled.span`
  text-align: right;
  font-family: 'Lato', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  margin-bottom: 16px;
  color: #115850;
`

export const EditedPricesNotice = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 12px;
  color: #c5581b;
  margin-top: 4px;
  margin-bottom: 8px;
  font-style: italic;
`

export const NextTierHintText = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 12px;
  color: #115850;
  margin-top: 4px;
  margin-bottom: 8px;
  font-style: italic;
`
